// Первым импортом: перехватчики эмуляции сети должны встать до создания supabase-клиента (IMGM-1435).
import './setup-network-chaos';
import './i18n';
import './index.css';
import './styles/tippy.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

const Root =
  process.env.NODE_ENV === 'development' ? (
    <App />
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

root.render(Root);
